<template>
  <div
    :class="[
      'w-full rounded-large bg-p h-full',
      !useGrid && 'marginTop md:w-1/2 xl:w-1/3 2xl:w-1/4 mt-4 md:mt-8',
      item.is_banner_product ? 'col-span-1 md:col-span-3 lg:col-span-3 xl:col-span-3' : '',
    ]"
    @click="$emit('click')"

  >
    <transition
      name="fade"
      v-if="menu.is_kiosk_full_picture"
    >
        <div
        :id="`_cart-item-${item.Id}`"
        :class="[
          'cursor-pointer relative clickAnimation h-full flex flex-col overflow-hidden',
          !useGrid && 'mx-6',
          menu.layout == 'frydate' ? 'shadow-none' : 'rounded-lg ',
          menuItemShadow
        ]"
       :style="{
        border: `${customThemeVariables['kiosk-current-cat--border']} 2px solid`,
        borderRadius: customThemeVariables['menu-item--radius'],
        backgroundImage: item.is_banner_product && !item.is_banner_description 
          ? `url(${item.pictureUrl || placeholderImage})` 
          : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: menuItemBackgroundColor
      }"
        @click="
          () => {
            if (!selectedMenuCategory.is_ordering_disabled && !item.is_sold_out) {
              if (item.is_banner_product) {
                if (item.is_buyable) {
                  addToCart(item);
                }
                else if(item.banner_link){
                  handleBannerLink(item)
                }
              } else {
                if (item.is_minimum_age_product) {
                  handleAgeConfirmation(item)
                }
                else
                {
                  isUpselling && isSelectedUpselling ? removeFromCart(item) : handleClick();
                }
              }
            }
          }
        "
      >
    <!-- Add button for the banner product  -->
    <div
      v-if="
        orderingEnabled &&
        !selectedMenuCategory.is_ordering_disabled && 
        !item.is_sold_out &&
        !item.is_snoozed &&
        item.is_banner_product && item.is_buyable && !item.is_banner_description
      "
      :class="[
        'xs:p-0 p-1 rounded-xl items-center justify-end w-auto inline-block  md:text-ceflex h-12 absolute bottom-4 right-4 px-4 py-2 text-white rounded',
        // /* theme.addToCart.addToCartButtonTextColor */
      ]"
      :style="makeStyles(btnOutlineBorder , btnOutlineBackground)"
    >
       <!-- 1 -->
      <div
        class="text-sm sm:px-2 text-primary-400 font-semibold xs:text-xxs rounded-full h-10 flex items-center justify-center"
        :style="makeStyles(addButtonRadius , kioskDetailText , kioskDetailBackground)"
      >
        <p class="text-3xl">
          <icon name="plus" size="25" :color="kioskDetailBackground" />
        </p>
      </div>
     </div>
        <span
          class="tag rounded-full px-2 p-1 absolute right-4 top-4"
          v-if="item['tag_' + language]"
          :style="kioskDetailText + kioskDetailBackground"
        >
          {{ item["tag_" + language] }}
        </span>
        <div
          :class="[
            'flex items-center overflow-hidden justify-center md:w-full flex-1',
            // item.pictureUrl && menu.product_images_enabled ? 'block' : 'hidden',
            menu.product_images_enabled && selectedMenuCategory.enable_product_images ? 'block' : 'hidden',
            menu.layout == 'frydate' ? 'rounded-t-none' : menu.is_kiosk_full_picture ? 'rounded-t-lg' : 'rounded-t-xl',
          ]"
        >
          <Picture
          :src="item.pictureUrl !== '' ? item.pictureUrl : placeholderImage"
          :item="item"
            alt
            :class="[
              'object-cover  h-full md:w-full',
              menu.is_kiosk_full_picture && 'rounded-none',
              item.is_banner_product && !item.is_banner_description ? 'opacity-0' : ''
            ]"
            @resize="handleResize"
            keepRatio     
          />
        </div>
        <div class="">
          <div :class="[menu.layout == 'frydate' ? 'py-2 px-2' : 'py-6 px-4',
          item.is_banner_product && !item.is_banner_description ? 'invisible' : '']">
            <div>
              <p
                :class="[
                  'font-semibold text-lg md:mt-1 xs:text-sm xs:w-9/12 xs:break-all md:flex w-full',
                ]"
                v-trans:name="item"
                :style="makeStyles(titleMain , titleTextTransform, menu.layout == 'frydate'? '' : titleFont)"
                ></p>
                <div class="justify-start">
                  <Allergens :item="item" />
                </div>
              <div class="flex items-center justify-between">
              <p
                :class="[
                  'text-new-primary font-semibold md:justify-center',
                  !orderingEnabled ? 'mb-2' : '',
                ]"
                :style="listsText"
                v-if="menu.is_kiosk_show_prices"
              >
                {{ displayPrice }}
              </p>
               <div
                v-if="
                  orderingEnabled &&
                  !selectedMenuCategory.is_ordering_disabled && 
                  !item.is_sold_out &&
                  !item.is_snoozed &&
                  (item.is_banner_product ? item.is_buyable : true)
                "
                :class="[
                  'xs:p-0 p-1 rounded-xl items-center justify-end w-auto inline-block  md:text-center flex h-12',
                  isSelectedUpselling ? 'hidden' : ''
                  // /* theme.addToCart.addToCartButtonTextColor */
                ]"
                :style="makeStyles(btnOutlineBorder , btnOutlineBackground)"
              >
                <!-- 1 -->
                <div
                  class="text-sm sm:px-2 text-primary-400 font-semibold xs:text-xxs rounded-full w-10 h-10 flex items-center justify-center"
                  :style="makeStyles(addButtonRadius , kioskDetailText , kioskDetailBackground)"
                >
                  <p class="text-3xl">
                    <icon name="plus" size="25" :color="kioskDetailBackground" />
                  </p>
                </div>
              </div>
              </div>
            </div>
        </div>
        <div v-if="item.is_sold_out || item.is_snoozed" class="flex justify-center items-center pb-2">
          <p class="text-center text-red-600 border border-2 px-2  border-red-500 rounded-xl">
          {{lang["sold_out"][language]}}
          </p>
        </div>
        </div>
      </div>
    </transition>

    <transition v-else name="fade">
      <div class="h-full">
        <ul
          @click="
          () => {
            if (!selectedMenuCategory.is_ordering_disabled && !item.is_sold_out && !item.is_snoozed) {
              if (item.is_banner_product) {
                if (item.is_buyable) {
                  addToCart(item);
                }
                else if(item.banner_link) {
                  handleBannerLink(item)
                }
              } else {
                if (item.is_minimum_age_product) {
                  handleAgeConfirmation(item)
                }
                else
                {
                  isUpselling && isSelectedUpselling ? removeFromCart(item) : handleClick();
                }
              }
            }
          }
        "
          :class="['onclickFocus flex flex-col h-full']"
        >
          <li class="flex flex-row h-full">
            <div
              :class="[
                'select-none',
                'rounded-md flex flex-1 items-center h-full',
              ]"
            >
              <div
                :class="[
                  'cursor-pointer w-full h-full flex border-b-2 md:border-b-0 md:rounded-b-xl mx-4 pb-6 md:pb-0 pl-4 md:pl-0 transition duration-500 items-center justify-between rounded-t-lg',
                  'flex-row md:flex-col',
                ]"
                :style="mediumWidth ? (item.is_banner_product && !item.is_banner_description ? '' : itemBackground) : ''"
              >
                <!-- left side product -->
                <div class="flex flex-row w-2/3 md:flex-col md:w-full"
                  :style="{
                      backgroundImage: `url(${
                        item.is_banner_product && !item.is_banner_description ? (item.pictureUrl !== '' ? item.pictureUrl : placeholderImage) : ''
                      })`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center'
                    }">
                  <div
                    :class="[
                      'flex-none flex items-center overflow-hidden rounded-lg justify-center',
                      // item.pictureUrl && menu.product_images_enabled
                      menu.product_images_enabled && selectedMenuCategory.enable_product_images
                        ? 'block'
                        : 'hidden',
                      'w-20 h-20 md:h-24 md:w-full',
                    ]"
                    :style="menuItemRadius"
                  >
                  <Picture     
                  :item="item"                
                      :src="item.pictureUrl !== '' ? item.pictureUrl : placeholderImage"
                      alt
                      :class="['object-cover  h-full md:w-full',
                      item.is_banner_product && !item.is_banner_description ? 'opacity-0' : '']"
                    />
                  </div>
                  <div
                    :class="[
                      'flex-grow ml-4 md:ml-0',
                      orderingEnabled ? '' : 'items-center flex',
                      item.is_banner_product && !item.is_banner_description ? 'invisible' : ''
                    ]"
                  >
                    <div class="flex-1 md:px-2">
                      <div :class="['font-medium justify-between']">
                        <!-- item name (title)-->
                        <span
                          :class="[
                            /*theme.body.text*/ 'font-semibold text-lg md:mt-1 md:text-center xs:text-sm xs:w-9/12 xs:break-all',
                            ,
                            'md:flex md:justify-center',
                          ]"
                          v-trans:name="item"
                          :style="titleMain+titleFont"
                        ></span>
                      </div>
                      <!-- item price -->
                      <div
                        :class="[
                          'text-xs flex text-product-gray md:text-center mt-1',
                          'md:flex md:justify-center',
                        ]"
                        v-trans:description="item"
                      ></div>

                      <!-- class="text-new-primary font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden"
                          :style="listsText" -->
                      <span
                        class="font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden xs:text-xs"
                        :style="text"
                        v-if="orderingEnabled"
                      >
                        {{ displayPrice }}
                      </span>

                      <div class="flex md:justify-center">
                      <allergens :item="item" />
                      </div>
                      <span
                        :class="[
                          'text-new-primary font-semibold text-sm mt-3 md:flex md:justify-center hidden md:block',
                          !orderingEnabled ? 'mb-2' : '',
                        ]"
                        :style="listsText"
                        v-if="menu.is_kiosk_show_prices"
                      >
                        {{ displayPrice }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- right side product -->
                <div
                  v-if="
                    orderingEnabled &&
                    !selectedMenuCategory.is_ordering_disabled
                    && !item.is_sold_out 
                    && !item.is_snoozed
                  "
                  class="flex items-center mt-2 md:flex-row md:w-full w-1/3 xs:justify-end"
                >
                  <div
                    v-if="
                      $_.countBy(
                        cartItems,
                        $_.omit(item, [
                          'upsell_item_available',
                          'upselling_custom_group_name',
                        ])
                      ).true || 0
                    "
                    :class="[
                      'flex items-center rounded-full w-full xs:justify-end',
                      /* theme.addToCart.backgroundColorPlus, */
                    ]"
                  >
                    <!-- buttton when 1 item is in basket -->
                    <div
                      :class="[
                        'flex flex-row md:rounded-t-none rounded-xl border-new-primary relative bg-primary-100 justify-center items-center border-2 w-full mr-4 md:mr-0 px-1 xs:mr-0 xs:w-4/5 xs:justify-end h-12',
                      ]"
                      :style="
                        btnOutlineActiveBorder + btnOutlineActiveBackground
                      "
                    >
                      <!-- min button -->
                      <div @click="removeFromCart(item)" class="md:w-1/3">
                        <button
                          :class="[
                            'sm:w-10 productClick fill-current focus:outline-none inline-block font-bold  rounded-full flex items-center',
                          ]"
                          :style="addButtonRadius"
                          :disabled="disableAddButton"
                        >
                        <IconMinus
                            :stroke="buttonImgColors"
                            :style="btnOutlineIcon"
                        />
                        </button>
                      </div>
                      <div
                        v-if="itemBeingAdded == item.Id"
                        :class="['spinner-white w-2 flex-1']"
                        style="position: relative !important"
                      >
                        <input
                          type="number"
                          readonly
                          :class="[
                            'focus:outline-none text-center text-new-primary font-bold text-md md:text-basecursor-default flex items-center outline-none w-full justify-center bg-primary-100 xs:text-xs h-10',
                          ]"
                          name="custom-input-number"
                          :value="
                            $_.countBy(
                              cartItems,
                              $_.omit(item, [
                                'upsell_item_available',
                                'upselling_custom_group_name',
                              ])
                            ).true || 0
                          "
                          :style="
                            btnOutlineActiveBackground + btnOutlineActiveText
                          "
                        />
                      </div>
                      <input
                        v-else
                        type="number"
                        readonly
                        :class="[
                          'static focus:outline-none text-center text-new-primary font-bold text-sm sm:text-md md:text-basecursor-default flex items-center outline-none w-full  md:w-1/3 justify-center bg-primary-100 xs:text-xs h-10',
                        ]"
                        name="custom-input-number"
                        :value="
                          $_.countBy(
                            cartItems,
                            $_.omit(item, [
                              'upsell_item_available',
                              'upselling_custom_group_name',
                            ])
                          ).true || 0
                        "
                        :style="
                          btnOutlineActiveBackground + btnOutlineActiveText
                        "
                      />
                      <!-- plus button -->
                      <div class="md:w-1/3 md:flex md:justify-end">
                        <button
                        @click="addToCart(item)"
                          :disabled="disableAddButton"
                          :class="[
                            'sm:w-10 productClick font-bold md:w-10 rounded-full cursor-pointer focus:outline-none flex items-center justify-end',
                          ]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="w-5 md:w-10 h-10 xs:w-3 xs:h-3"
                          >
                            <path
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              fill="none"
                              :stroke="buttonImgColors"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else
                    :class="[
                      'md:items-center w-full justify-center mr-4 md:mr-0 text-right xs:mr-0 xs:w-4/5 xs:justify-end',
                    ]"
                    @click="addToCart(item)"
                  >
                    <!-- button without item selected in cart -->
                    <div
                      v-if="
                        orderingEnabled &&
                        !selectedMenuCategory.is_ordering_disabled
                        && !item.is_sold_out
                        && !item.is_snoozed
                        && item.is_banner_product ? item.is_buyable : true
                      "
                      :class="[
                        'xs:p-0 p-1 md:rounded-t-none rounded-xl items-center justify-end transition duration-500 border-2 w-auto inline-block md:w-full md:text-center flex justify-center',
                        /*theme.addToCart.addToCartButtonBackgroundColor*/ 'bg-white h-12',
                      ]"
                      :style="btnOutlineBorder + btnOutlineBackground"
                    >
                      <p
                        class="text-sm sm:px-2 text-primary-400 font-semibold xs:text-xxs"
                        :style="btnOutlineText"
                      >
                        + {{ lang["add_to_cart"][language] }}
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="!orderingEnabled">
                  <span
                    class="text-new-primary font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden xs:text-sm"
                    :style="listsText"
                  >
                    {{ displayPrice }}
                  </span>
                </div>
                <div v-if="item.is_sold_out || item.is_snoozed" class="flex justify-center items-center pb-2">
                  <p class="text-center text-red-600 border border-2 px-2  border-red-500 rounded-xl">
                    {{lang["sold_out"][language]}}
                  </p>
                </div>

              </div>

              <div
                :class="['text-gray-600 text-xs']"
                v-if="$route.name == 'Home'"
              ></div>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Allergens from "./Allergens.vue";
import Icon from "./Icon.vue";
import lang from "../lang";
import _ from "lodash";
import animateItemToCart from "../utils/animate";
import IconMinus from "./icons/iconMinus.vue";

export default {
  data() {
    return {
      window: {
        width: 0,
        height: 0,
      },
      lang: lang,
      itemBeingAdded: "",
      accumulativeAdditions: [],
      selectedModifiers: [],
      modifiersMessage: "",
      disableAddToCartButton: false,
      disableAddButton: false,
      mediumWidth: false,
      listKiosk: false,
      numberOfOrder: 1,
      allChosenItems: [],
      deleteCorrectitem: [],
      currentItemPrice: 0,
    };
  },
  props: {
    item: Object,
    useGrid: Boolean,
    isUpselling: {
      type: Boolean,
      required: false,
    },
    isSelectedUpselling: {
      type: Boolean,
      required: false,
      default: false,
    },
    upsellGroup: {
      type: Object,
      required: false,
    },

  },
  components: {
    Allergens,
    Icon,
    IconMinus
},
  methods: {
    handleClick() {
      // Emit event to parent
      this.$emit('handleUpsell', this.upsellGroup, this.item);
      if (this.isUpselling) {
        this.$nextTick(() => {
          if (this.isSelectedUpselling) {
            this.addToCart(this.item);
          }
        }); 
      }
      else {
        this.addToCart(this.item);
      }
    },
    addToCart(item) {
      if (this.isUpselling) {
        const selectedItemsInGroup = this.selectedUpsellItems.filter(selectedItem =>
        this.upsellGroup.groupMenuItems.some(groupItem => groupItem.Id === selectedItem.Id)
        ).length;
        if(selectedItemsInGroup > this.upsellGroup.maxSelectedAmount && this.upsellGroup.maxSelectedAmount != 0) {
          return
        }
      }
      this.$store.commit("updateItemPrice", item.price);
      this.$store.commit("Cart/updateOrderItemCount", 1);
      if (this.disableAddButton != true) {
        this.disableAddButton = true;
        if (
          this.orderingEnabled &&
          !this.selectedMenuCategory.is_ordering_disabled
          && !item.is_sold_out
          && !item.is_snoozed
        ) {
          this.currentItem = item;

          this.$store.commit("updateCategoryId", item.MenuCategoryId);

          this.itemBeingAdded = this.currentItem.Id;
          this.$store
            .dispatch("Cart/GET_MENU_ITEM_ORDERING", this.currentItem.Id)
            .then((response) => {
              this.itemBeingAdded = "";
              // if item has modifiers -> show the modifier modal
              if (response.data.Modifiers.length || response.data.MenuItem[`description_${this.language}`]) {
                this.currentItem = item;

                this.modifiers = response.data.Modifiers;
                // Create a Set to store unique addition_group values
                const uniqueGroups = new Set();
                // Create an array to store all additionStep values
                const uniqueAdditionSteps = new Set();

                // Add each addition_group value to the Set and unique additionStep value to the set
                this.modifiers.forEach(item => {
                  uniqueGroups.add(item.additionStep);
                  uniqueAdditionSteps.add(item.additionStep);

                });

                // The size of the Set is the number of distinct addition_groups
                const distinctGroupCount = uniqueGroups.size;
                // Convert the Set of unique addition steps back to an array
                const additionStepsArray = Array.from(uniqueAdditionSteps);

                if (distinctGroupCount > 0) {
                  this.$store.commit("updateModifiersSelectionGroups", distinctGroupCount);
                }
                // Save the array of all additionStep values
                this.$store.commit("saveAdditionStepsArray", additionStepsArray);
                
                // If product contains single modifier with single addition:
                // Add product alongwith modifier addition to the cart directly

                if (response.data.Modifiers.length == 1 && response.data.Modifiers[0].Additions.length == 1 && response.data.Modifiers[0].minSelectedAmount == 1) {
                  let tempCurrentItem = this.$_.cloneDeep(this.currentItem);
                  tempCurrentItem["OrderItemAdditions"] = [];
                  tempCurrentItem["OrderItemAdditions"].push({
                  Addition: this.modifiers[0].Additions[0],
                  });
                  this.$store
                  .dispatch("Cart/UPDATE_ORDER", {
                    operation: "add",
                    item: tempCurrentItem,
                  })
                }
                else {
                  this.$modal.show("item-modifiers");
                }
              } else {
                // update the order
                animateItemToCart(this.currentItem);

                let updateOrder = () => {
                  this.debounceCartItems.forEach((el) => {
                    this.$store.dispatch("Cart/UPDATE_ORDER", {
                    operation: "add",
                    item: el,
                    }); 
                    })
                  this.$store.commit("Cart/clearDebounceCartItems")
                }

                  this.$store.commit("Cart/addDebounceCartItems", item)
                  let debounceMethod = _.debounce(updateOrder, 50)
                  debounceMethod()
            
              }
              // put some time into the add button so customers cant add infinity items
              setTimeout(() => (this.disableAddButton = false), 150);
            })
            .catch(() => {
              this.itemBeingAdded = "";
            });
        }
        if (this.isUpselling) {
          if (this.upsaleGroups.length === 1 && this.upsaleGroups[0].maxSelectedAmount === 0) {
            this.$modal.hide("upselling-items");
          }
        }
      }
    },
    // removes an item from the cart
     removeFromCart(item) {
      if (this.isUpselling) {
        // Emit event to parent for handling upsell
        this.$emit('handleUpsell', this.upsaleGroupIndex, this.item);
        
        this.$nextTick(() => {
          // Continue with removeFromCart logic after upsell handling
          this.removeItemFromCart(item);
        });
      } else {
        this.removeItemFromCart(item);
      }
    },
    removeItemFromCart(item) {
      this.deleteCorrectitem = [];
      this.allChosenItems = [];

      for (let i = 0; i < this.cartItems.length; i++) {
        if (item.Id == this.cartItems[i].Id) {
          this.allChosenItems.push(this.cartItems[i]);
        }
      }
      this.deleteCorrectitem.push(_.uniqWith(this.allChosenItems, _.isEqual));
      this.$emit("removeItem", {
        correctItems: this.deleteCorrectitem,
        item,
      });
      // if there are more items with the same id but with diffrend additions we show a modal so we can choose what we want to delete
      if (this.deleteCorrectitem[0].length != 1 && !this.isUpselling) {
        this.$modal.show("deleteItem");
      } else {
        if (this.disableAddButton != true) {
          this.disableAddButton = true;
          this.currentItem = item;
          this.itemBeingAdded = this.currentItem.Id;

          /**
           * Sanitising the item before sending to the store for the removal. (Related to Upsale)
           * Upsaling adds few other key-values to the items. (Removing that.)
           */
          this.$store
            .dispatch("Cart/UPDATE_ORDER", {
              operation: "remove",
              item: this.$_.omit(item, [
                "upsell_item_available",
                "upselling_custom_group_name",
              ]),
            })
            .then(() => {
              this.itemBeingAdded = "";
              setTimeout(() => (this.disableAddButton = false), 150);
            })
            .catch(() => {
              this.itemBeingAdded = "";
            });
        }
      }
    },
    // handle the picture sizes
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width >= 777) {
        this.$store.commit("updateIsMobileDevice", false);
      } else {
        this.$store.commit("updateIsMobileDevice", true);
      }
    },
    handleBannerLink(item) {
      const index = this.menuCategories.findIndex(el => el.Id == item.banner_link);
      window.$eventBus.$emit("directToBannerLink", index)
      let category = this.menuCategories.find(el => el.Id == item.banner_link);

      if (item.banner_link == this.selectedMenuCategory) {
        return;
      }
      this.$store.commit("updateSelectedMenuCategory", category);
      this.$store.commit("updateCategoryId", item.banner_link);
      this.$store.commit("updateIsSubSubCategory", false);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.banner_link);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", category);

        this.$router
          .push("/" + this.$route.params.menuHash + "/category/" + item.banner_link)
          .catch(() => {});
      } else {
        if(this.infiniteScroll){
          this.$emit('category-changed',item.banner_link)
        }else{
          this.$store.dispatch("GET_CATEGORY");
          this.scrollSelectedCategoryIntoView();
        }
        this.$router
          .push("/" + this.$route.params.menuHash + "/sub/category/" + item.banner_link)
          .catch(() => {});
      }
    },
    scrollSelectedCategoryIntoView() {
      this.$nextTick(() => {
        if(this.$refs?.menuCategoryId?.[0]&&this.$refs?.scrollbar){
          let activeBoundedClientRec=this.$refs.menuCategoryId[0].getBoundingClientRect();
          let scrollbarBoundedClientRec=this.$refs.scrollbar.getBoundingClientRect();
          if(activeBoundedClientRec.x<0){
            this.$refs.scrollbar.scroll(this.$refs.scrollbar.scrollLeft-this.$refs.scrollbar.offsetLeft+activeBoundedClientRec.x,0);
          }else if(activeBoundedClientRec.right>scrollbarBoundedClientRec.width){
              this.$refs.scrollbar.scroll(this.$refs.scrollbar.scrollLeft+activeBoundedClientRec.right-scrollbarBoundedClientRec.width,0)
          }
        }
      });
    },
    handleAgeConfirmation(item) {
      this.$modal.show('confirmAge')
      this.$store.commit("updateMinimumAgeProduct", item)
    },
  },
  mounted() {},
  created() {
    if (window.innerWidth > 769) {
      this.mediumWidth = true;
    }
  },
  computed: {
    currentItem: {
      get() {
        return this.subCategoryCurrentItem;
      },
      set(value) {
        return this.$store.commit("Cart/updateSubCategoryCurrentItem", value);
      },
    },
    modifiers: {
      get() {
        return this.subCategoryCurrentItemModifier;
      },
      set(value) {
        return this.$store.commit(
          "Cart/updateSubCategoryCurrentItemModifier",
          value
        );
      },
    },
    displayPrice() {
      if (this.item.price === 0 && this.item.isComboDeal) {
        return this.lang["make_choice"][this.language]
      } else if(this.item.price > 0) {
        return this.pricify(this.item.price)
      } else {
        return '';
      }
    },
    ...mapGetters([
      "menuItems",
      "theme",
      "currency",
      "orderingEnabled",
      "selectedMenuCategory",
      "isListDisplayed",
      "isSubSubCategory",
      "parentSelectedMenuCategory",
      "processCurrentName",
      "menu",
      "floatButtonLabel",
      "modifierNumber",
      "isIOSChrome",
      "upselling",
      "orderData",
      "itemPrice",
      "menuCategories",
      "placeholderImage"

    ]),
    ...mapGetters("Cart", [
      "subCategoryCurrentItemModifier",
      "subCategoryCurrentItem",
      "cartItems",
      "debounceCartItems",
      "totalPriceValueWithCosts",
      "orderItemCount",
      "upsellMaxSelection",
      "selectedUpsellItems",
      "upsaleGroups",
    ]),
    ...mapGetters("Theme", [
      "btnMainText",
      "addButtonRadius",
      "menuItemRadius",
      "titleFont",
      "titleTextTransform",
      "btnOutlineBorder",
      "btnOutlineBackground",
      "btnOutlineText",
      "btnOutlineIcon",
      "btnOutlineActiveBorder",
      "btnOutlineActiveBackground",
      "btnOutlineActiveText",
      "btnOutlineActiveIcon",
      "text",
      "listsText",
      "paymentBtnBackground",
      "paymentBtnText",
      "btnDestructiveBackground",
      "btnDestructiveIcon",
      "titleMain",
      "buttonImgColors",
      "mainSubCategorysBackground",
      "itemBackground",
      "kioskDetailBackground",
      "kioskDetailText",
      "kioskItemBorder",
      "addMoreItemsIconBackground",
      "addMoreItemsIcon",
      "addMoreItemsNumber",
      "processTekst",
      "kioskCategoryTitle",
      "itemDescription",
      "menuItemShadow",
      "menuItemBackgroundColor",
      "customThemeVariables",
      "listsActiveBackground",
      "activeUpsellItemBorder",
    ]),
    ...mapGetters(["language", "menuSubCategories"]),
  },
};
</script>

<style></style>
